export class PrivacyPageComponent implements ng.IComponentOptions {
  public controller: any = PrivacyPageController;
  public template: string =
  `
  <div class="container container-fluid padding-2">
    <div class="row">
      <div class="col-md-12">
        <h1>Privacy Policy</h1>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <h4>1. Your Privacy</h4>
        <p>This page explains our privacy policy which includes the use and protection of information submitted by visitors.
        If you make a transaction or send an e-mail containing personal information, this information may be shared with other government agencies to help provide a more efficient and effective service.
        For example, resolving a complaint that requires feedback from other agencies.</p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <h4>2. Information Collected</h4>
        <p>No personal information will be collected when you visit this portal except for information given by you via e-mail.</p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <h4>3. What Happens When I Use the External Links (to the Other Portals or other websites) Contained in this Portal ?</h4>
        <p>This portal contains external links to the other portals or other web sites. This privacy policy applies to this site only. It should be noted that the portal or website in the links may have different privacy policies and visitors are advised to read and understand the privacy policies of each portal or website that they visit.</p>
      </div>
    </div>
    <div class="row margin-bottom-40px">
      <div class="col-md-12">
        <h4>4. Policy Amendments</h4>
        <p>If this privacy policy is amended, changes will be updated on this page. By regularly reviewing this page, you will be getting the information on how the information is collected, how it is used, under what circumstances and how the information is shared with other parties.</p>
      </div>
    </div>
    <br/>
    <br/>
    <i>(Source from data.gov.my)</i>
  </div>
  `;
}

export class PrivacyPageController {
  public static $inject: Array<string> = ['$anchorScroll'];
  constructor (private $anchorScroll: ng.IAnchorScrollService) {

  }

  public $onInit() {
    this.$anchorScroll();
  }
}
